export function removeSpecialCharacters(text: string | null): string | null {
  if (!text) return null;
  return text.replace(/[^a-zA-Z0-9]/g, '');
}

export function removeAccentsFromString(string: string): string {
  if (!string) return '';
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function parseAddress(fullAddress: string) {
  const addressTypes = ['RUA', 'AV', 'AVENIDA', 'PRAÇA'];
  const parts = fullAddress.toUpperCase().split(' ');
  const type = parts.shift() || '';

  if (addressTypes.includes(type)) {
    const address = parts.join(' ');
    return { type, address };
  } else {
    return { type: '', address: fullAddress };
  }
}
